import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { UserProvider } from "./context.js/userContext";
import InjectedContext from "./injectContext";
import { CheckHistoryPaid } from "functions/negdi/checkHistoryPaid";

const PaymentSide = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const secureId = queryParams.get("secureId")
    ? String(queryParams.get("secureId")).split("?")[0]
    : null;
  const historyId = queryParams.get("historyId")
    ? String(queryParams.get("historyId")).split("?")[0]
    : null;
  useEffect(() => {
    if (historyId) CheckHistoryPaid(historyId);
  }, [historyId]);
  return (
    <UserProvider>
      <InjectedContext
        secureId={secureId}
        defaultMethod={historyId ? "CARD" : "QPAY"}
      />
    </UserProvider>
  );
};

export default PaymentSide;
